export const CupisClientStatusEnum = {
    ClientDetailsChecking: 1,
    OpenDocumentsPage: 2,
    Success: 3,
    Restricted: 4
}

export const CupisClientStatusEnumV2 = {
    Unknown: 0,
    RegisteredSimple: 9,
    RegisteredFull: 12,
    BindFailed: 16,
    Locked : 17,
	BindDeleted: 18,
    New: 20,
    AlreadyBound: 23,
    NotRus: 200
}